export enum Routes {
	CLAIM = '/claim',
	REQUEST_MONITORING = '/request-monitoring',
	PODCAST_CLAIM = 'podcast/auth/claim',
	PODCAST_REQUEST_MONITORING = 'podcast/auth/request-monitoring',

	HOME = '/',
	PODCAST_HOME = '/podcasts',
	PODCAST_SIGN_UP = '/podcast/auth/signup',
	PODCAST_LOGIN = '/podcast/auth/login',
	PODCAST_FORGOT_PASSWORD = '/podcast/auth/password/forgot',

	SIGN_UP = '/user/signup',
	LOGIN = '/user/login',
	SIGNUP_TOKEN_EXPIRED = '/user/signup-token-expired',
	LEGACY_SIGNUP_TOKEN_EXPIRED = '/user/legacy-signup-token-expired',
	FORGOT_PASSWORD_TOKEN_EXPIRED = '/user/forgot-password-token-expired',
	EMAIL_CONFIRMATION = '/user/email-confirmation-notice',
	SIGN_UP_CONFIRMATION = '/user/signup-confirmation-notice',
	FORGOT_PASSWORD = '/user/password/forgot',
	PASSWORD_RESET = '/user/password/reset',
	PASSWORD_CREATE = '/user/password/create',
	PASSWORD_FORCE_RESET_NOTICE = '/user/password/force-reset-notice',

	ANALYTIC = '/analytic',
	ANALYTIC_ARTIST_MARKETING = '/analytic/view',
	ANALYTIC_ARTIST_VIEW = '/analytic/artist/view',
	ANALYTIC_LABEL_VIEW = '/analytic/label/view',
	ANALYTIC_PROVIDER_VIEW = '/analytic/provider/view',
	ANALYTIC_LAB = '/analytic/labs',
	ANALYTIC_ARTIST = '/analytic/artist',
	ANALYTIC_ALBUM = '/analytic/album',
	ANALYTIC_TRACK = '/analytic/track',
	ANALYTIC_PLAYLIST = '/analytic/playlist',
	PROFILES = '/profiles',
	CHARTS = '/charts',
	PLAYLIST_REPORT = '/playlist-report',
	DELIVERIES = '/deliveries',
	EDIT_ARTIST = '/edit/artist',
	USERS_CREATE = '/users/create',
	USERS = '/users',
	MY_PROFILE = '/my-profile',
	SUB_LABELS = '/sub-labels',
	PROVIDER_POLICY = '/content-policy/guide',
	CONTENT_POLICY = '/content-policy',
	PITCHES = '/pitches',
	PITCHES_CREATE = '/pitches/create',
	PITCHES_IMPORT = '/pitches/import',
	CAMPAIGNS = '/campaigns',
	CAMPAIGNS_CREATE = '/campaigns/create',
	COPYRIGHT_CLAIMS = '/copyright-claims',
	COPYRIGHT_CLAIMS_CREATE = '/copyright-claims/create',
	LOGOUT = '/user/logout',
	LABS = '/labs',
	ERROR_404 = '/404',
	ERROR_403 = '/403',
	ERROR_500 = '/500',
	AUTH_CALLBACK = '/auth/callback',
}
